module.exports = __webpack_public_path__ + "prs2024.png?1d9913bf0cfa3d74ca6d6c987e8964b7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/prs2024.png
// module id = 249
// module chunks = 0